// Admin price fields ↔ integer minor units, for every storefront. Both list
// currencies (USD on ASCPS, BRL on Formed) have two decimal places, so one
// parser is correct for both. Display formatting is not here: it depends on the
// storefront's currency and locale, so each app keeps its formatter in
// `lib/price.ts`. Client-safe.

// Digits, then optionally one decimal separator (dot or comma) and at most two
// decimals. A thousands separator is refused rather than guessed: the old
// replace-the-first-comma parser read '1.999,00' as 1.999 and stored R$2,00.
const PRICE_INPUT_RE = /^\d+(?:[.,]\d{1,2})?$/

/** Minor units for a typed price; null for an empty, malformed or negative value. */
export function parsePriceInputToCents(value: string): number | null {
  const trimmed = value.trim()
  if (!PRICE_INPUT_RE.test(trimmed))
    return null
  return Math.round(Number(trimmed.replace(',', '.')) * 100)
}

/** The value a price `<input type="number">` starts with; empty for an unset price. */
export function centsToPriceInput(cents: number | null | undefined): string {
  if (cents === null || cents === undefined)
    return ''
  return (cents / 100).toFixed(2)
}
